import { browserName } from "react-device-detect";
import { ErrorUI } from "../UI/Modals/Modals";
import { staticVar } from "../../services/Constants";

const isSupportBrowser = () => {
    if (browserName === "Safari" || browserName === "Firefox") {
        ErrorUI(staticVar.noSupport);
        return false;
    }  
    return true;
  }


export default isSupportBrowser